import { render, staticRenderFns } from "./OrderExchangeOrReturn.vue?vue&type=template&id=4966c95f&scoped=true"
import script from "./OrderExchangeOrReturn.vue?vue&type=script&lang=js"
export * from "./OrderExchangeOrReturn.vue?vue&type=script&lang=js"
import style0 from "./OrderExchangeOrReturn.vue?vue&type=style&index=0&id=4966c95f&prod&lang=scss&scoped=true"
import style1 from "./OrderExchangeOrReturn.vue?vue&type=style&index=1&id=4966c95f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4966c95f",
  null
  
)

export default component.exports